import { defineStore } from 'pinia'
import { ref } from '@vue/composition-api'
import useLayoutNotice from './notice.js'
import useFirstNavs from './useFirstNavs.js'

export const useLayoutStore = defineStore('layout', () => {
  const pageLoading = ref(false)

  const toggleLoading = (bool = false) => {
    pageLoading.value = bool
  }

  return {
    pageLoading,
    toggleLoading,
    ...useLayoutNotice(),
    ...useFirstNavs()
  }
})
